// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextFilledSvg from "@ant-design/icons-svg/es/asn/FileTextFilled";
import AntdIcon from '../components/AntdIcon';

var FileTextFilled = function FileTextFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextFilledSvg
  }));
};

FileTextFilled.displayName = 'FileTextFilled';
export default React.forwardRef(FileTextFilled);